const normalizeValue = (value?: string) => value?.trim().toLowerCase() ?? '';

const membershipUrls = ['/bli-medlem', '/medlemskap', '/naf-medlem'];
const membershipCtaText = ['bli medlem', 'bli naf medlem', 'bli naf-medlem'];

const benefitUrls = ['medlemsfordeler'];
const benefitCtaText = ['fordeler'];

type PromotionEventTrackingData = {
  promotion_id: string;
  promotion_name: string;
};

const membershipPromotion: PromotionEventTrackingData = {
  promotion_id: 'bli-medlem',
  promotion_name: 'Bli medlem',
};

const benefitPromotion: PromotionEventTrackingData = {
  promotion_id: 'medlemsfordeler',
  promotion_name: 'Medlemsfordeler',
};

export const getPromotionEventTrackingData = (text?: string, url?: string): PromotionEventTrackingData | undefined => {
  const normalizedText = normalizeValue(text);
  const normalizedUrl = normalizeValue(url);

  const isBenefitText = benefitCtaText.some((ctaText) => normalizedText.includes(ctaText));
  if (isBenefitText) {
    return benefitPromotion;
  }

  const isBenefitUrl = benefitUrls.some((benefitUrl) => normalizedUrl.includes(benefitUrl));
  if (isBenefitUrl) {
    return benefitPromotion;
  }

  const isMembershipText = membershipCtaText.some((ctaText) => normalizedText.includes(ctaText));
  if (isMembershipText) {
    return membershipPromotion;
  }

  const isMembershipUrl = membershipUrls.some((membershipUrl) => normalizedUrl.includes(membershipUrl));
  if (isMembershipUrl) {
    return membershipPromotion;
  }

  return undefined;
};
